import { connect } from "react-redux";
import UberStatusCell from "./UberStatusCell";
import { showUberCancelResolution } from "../../../actions/modal";

/**
 * Connecte UberStatusCell au store Redux.
 *
 * mapDispatchToProps:
 * - onResolveClick: dispatch showUberCancelResolution pour ouvrir la modal de resolution
 */
const mapDispatchToProps = (dispatch) => {
  return {
    onResolveClick: (task, dock) => dispatch(showUberCancelResolution(task, dock)),
  };
};

export default connect(null, mapDispatchToProps)(UberStatusCell);